import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useToast} from '@/hooks/use-toast'
import {useI18n} from '@/i18n'
import {useServices} from '@/services/context'

const SYNC_RUNS_KEY = 'inbound-connectors-sync-runs'
const SYNC_RECORDS_KEY = 'inbound-connectors-sync-records'
const SYNC_STATUS_KEY = 'inbound-connectors-sync-status'

function usePausedSyncResolutionMutation(
    connectorId: string,
    resolve: (runId: string) => Promise<unknown>,
    successMessage: string,
) {
    const queryClient = useQueryClient()
    const {toast} = useToast()

    return useMutation({
        mutationFn: resolve,
        onSuccess: () => {
            toast({description: successMessage})
            queryClient.invalidateQueries({queryKey: [SYNC_RUNS_KEY, connectorId]})
            queryClient.invalidateQueries({queryKey: [SYNC_STATUS_KEY, connectorId]})
            queryClient.invalidateQueries({queryKey: [SYNC_RECORDS_KEY, connectorId]})
        },
    })
}

export function useApprovePausedSync(connectorId: string) {
    const services = useServices()
    const i18n = useI18n()
    return usePausedSyncResolutionMutation(
        connectorId,
        (runId: string) => services.inboundConnectors.approveSyncRun(connectorId, runId),
        i18n.inboundConnectors.syncRunApproveSuccess,
    )
}

export function useRejectPausedSync(connectorId: string) {
    const services = useServices()
    const i18n = useI18n()
    return usePausedSyncResolutionMutation(
        connectorId,
        (runId: string) => services.inboundConnectors.rejectSyncRun(connectorId, runId),
        i18n.inboundConnectors.syncRunRejectSuccess,
    )
}
